import { gql } from "@apollo/client";

export const AddPaymentLink = gql`
  mutation Mutation($input: AddProductInput!) {
    addProduct(input: $input) {
      message
      product {
        paymentLinks {
          options {
            collectCustomersShippingAddress
            limitTheNumberOfPayments
            allowBusinessCustomersToProvideTaxIds
            collectTaxAutomatically
            taxCategory
            includeTaxInPrice
          }
        }
        id
        name
        description
        images
        type
        minAmount
        maxAmount
        price
        organizationId
        currency
        paymentType
        billingPeriod
        createdAt
        updatedAt
        quantity
        customPeriod {
          number
          period
        }
        status
      }
    }
  }
`;

export const DeletePaymentLink = gql`
  mutation DeleteProduct($deleteProductId: String!) {
    deleteProduct(id: $deleteProductId) {
      message
    }
  }
`;

export const EditPaymentLink = gql`
  mutation UpdateProduct(
    $updateProductId: ID!
    $input: UpdateProductRequestBody!
  ) {
    updateProduct(id: $updateProductId, input: $input) {
      message
    }
  }
`;

// export const CreatePaymentLink = gql`
//   mutation CreatePaymentLink($input: PaymentLinkInput) {
//     createPaymentLink(input: $input)
//   }
// `;

export const CreatePaymentLink = gql`
  mutation CreatePaymentLink($input: PaymentLinkInput) {
    createPaymentLink(input: $input) {
      createdAt
      updatedAt
      advanceOption {
        redirectAfterPayment
        successMessage
        useYourCustomLink
      }
      id
      options {
        collectCustomersShippingAddress
        limitTheNumberOfPayments
        allowBusinessCustomersToProvideTaxIds
        collectTaxAutomatically
        taxCategory
        includeTaxInPrice
      }
      products {
        id
        name
        price
        description
        type
        status
        paymentType
        organizationId
        minAmount
        maxAmount
        createdAt
        updatedAt
        customPeriod {
          number
          period
        }
        currency
      }
      shortcode
      type
    }
  }
`;

export const CreateOrUpdateAdvanceBrandSettings = gql`
  mutation CreateOrUpdateAdvanceBrandSettings($input: BrandSettingsInput!) {
    createOrUpdateAdvanceBrandSettings(input: $input) {
      id
      primaryColor
      secondaryColor
      primaryLogo
      whiteBackgroundLogo
      Heading1fontStyle
      Heading1fontSizes
      Heading2fontStyle
      Heading2fontSizes
      SubHeadingfontStyle
      SubHeadingfontSizes
      companyName
      companyDescription
      keywords
      socialMediaLinks
      backgroundImages
      headerImages
      customCss
      emailTemplates
      meta
      legalInformation
      status
    }
  }
`;

export const DisableBrandSettings = gql`
  mutation disablePaymentLinkBrandSettings(
    $input: DisablePaymentLinkBrandSettingsInput!
  ) {
    id
    primaryColor
    secondaryColor
    primaryLogo
    whiteBackgroundLogo
    Heading1fontStyle
    Heading1fontSizes
    Heading2fontStyle
    Heading2fontSizes
    SubHeadingfontStyle
    SubHeadingfontSizes
    companyName
    companyDescription
    keywords
    socialMediaLinks
    backgroundImages
    headerImages
    customCss
    emailTemplates
    meta
    legalInformation
    organizationId
    status
    createdAt
    updatedAt
  }
`;

export const CreateTransactionSettings = gql`
  mutation CreateBrandSettings($input: CreateBrandSettingsInput!) {
    createBrandSettings(input: $input) {
      id
      transactionCurrency
      paymentMethods
      paymentGatewayIntegration
      transactionFees {
        flatFee
        percentageFee
      }
      organizationId
      status
    }
  }
`;

export const UpdateTransactionSettings = gql`
  mutation EditBrandSettings($input: EditBrandSettingsInput!) {
    editBrandSettings(input: $input) {
      id
      transactionCurrency
      paymentMethods
      paymentGatewayIntegration
      transactionFees {
        flatFee
        percentageFee
      }
      organizationId
      status
    }
  }
`;

export const DisableTransactionSettings = gql`
  mutation DisableBrandSettings($input: DisableBrandSettingsInput!) {
    disableBrandSettings(input: $input) {
      id
      transactionCurrency
      paymentMethods
      paymentGatewayIntegration
      transactionFees {
        flatFee
        percentageFee
      }
      organizationId
      status
    }
  }
`;

export const MakePlaidTransferPayment = gql`
  mutation MakePlaidTransferPayment($payload: MakePlaidTransferPayload) {
    makePlaidTransferPayment(payload: $payload)
  }
`;
